import { SegmentSearchParameter } from '@websky/graphql';

import { API_DATE_FORMAT, format } from '../../../../utils';
import { SegmentValue } from '../../../../Checkout/types';
import { ExchangeSegmentState } from '../model/types';

export function transformSegmentToParams(segment: SegmentValue & ExchangeSegmentState): SegmentSearchParameter {
	return {
		date: format(segment.selectedDate ?? segment.date, API_DATE_FORMAT),
		departure: { iata: segment.departure.iata },
		arrival: { iata: segment.arrival.iata }
	};
}
